export default __webpack_public_path__ + "static/nlc-favicon-36e3ff6dcfe54739cd3db94dd8cb9ac7.png";